// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  companyPositionListModalType:"create",
  companyPositionListModalVisible:false,
  cuCompanyPositionListName:{},
  coPositionListPage:1,
  temModalVisible:false,
  submittempPending:false,
  cuPositionTempListName:{},
  submittempListPending:false,
  cuPositionTempName:{},
  positionTempType:'create',
  submitPositionListPending:false,
  positionTypeList:[],
  positionTypePage:1,
  positionTypeSize:10,
  positionTypeTotal:0,
  positionCategoryPage:1,
  positionCategorySize:10,
  positionCategoryTotal:0,
  positionTypeById:{},
  positionCategoryById:{},
  positionTypeModalType:"create",
  positionTypeModalVisible:false,
  currentPositionType:{},
  originPositionTypeTree:[],
  getPositionTypeListPending: false,
  getPositionTypeListError: null,
  submitPositionTypePending: false,
  submitPositionTypeError: null,
  deletePositionTypePending: false,
  deletePositionTypeError: null,
  getAllPositionTypePending: false,
  getAllPositionTypeError: null,
  positionTypeTree:{},
  allTypeById:[],
  companyTypeList:[],
  companyTypePage:1,
  companyTypeSize:10,
  companyTypeTotal:0,
  companyTypeById:{},
  companyTypeModalType:"create",
  companyTypeModalVisible:false,
  addTagModalType:'create',
  companyPositionModalType:"create",
  currentTags:['ordinary','tech','loser','design'],
  tagModalVisible:false,
  submittagsPending:false,
  companyPositionModalVisible:false,
  submitCompanyPositionPending:false,
  companyPositionPage:1,
  currentCompanyPositionName:{},
  currentCompanyType:{},
  getCompanyTypeListPending: false,
  getCompanyTypeListError: null,
  submitCompanyTypePending: false,
  submitCompanyTypeError: null,
  deleteCompanyTypePending: false,
  deleteCompanyTypeError: null,
  areaList:[],
  areaPage:1,
  areaSize:10,
  areaTotal:0,
  areaById:{},
  areaModalType:"create",
  areaModalVisible:false,
  currentArea:{},
  getAreaListPending: false,
  getAreaListError: null,
  submitAreaPending: false,
  submitAreaError: null,
  deleteAreaPending: false,
  deleteAreaError: null,
  eduList:[],
  eduPage:1,
  eduSize:10,
  eduTotal:0,
  eduById:{},
  eduModalType:"create",
  eduModalVisible:false,
  currentEdu:{},
  getEduListPending: false,
  getEduListError: null,
  submitEduPending: false,
  submitEduError: null,
  deleteEduPending: false,
  deleteEduError: null,
  benefitsList:[],
  benefitsTypeTree: null,
  benefitsPage:1,
  benefitsSize:10,
  benefitsTotal:0,
  benefitsById:{},
  benefitsModalType:"create",
  benefitsModalVisible:false,
  currentBenefits:{},
  getBenefitsListPending: false,
  getBenefitsListError: null,
  submitBenefitsPending: false,
  submitBenefitsError: null,
  deleteBenefitsPending: false,
  deleteBenefitsError: null,
  certTypeList:[],
  certTypePage:1,
  certTypeSize:10,
  certTypeTotal:0,
  certTypeById:{},
  certTypeModalType:"create",
  certTypeModalVisible:false,
  currentCertType:{},
  originCertTypeTree:[],
  getCertTypeListPending: false,
  getCertTypeListError: null,
  submitCertTypePending: false,
  submitCertTypeError: null,
  deleteCertTypePending: false,
  deleteCertTypeError: null,
  userTagList:[],
  userTagPage:1,
  userTagSize:10,
  userTagTotal:0,
  userTagById:{},
  userTagTree:{},
  originUserTagTree:[],
  allUserTagById:{},
  userTagModalType:"create",
  userTagModalVisible:false,
  currentUserTag:{},
  getUserTagListPending: false,
  getUserTagListError: null,
  submitUserTagPending: false,
  submitUserTagError: null,
  deleteUserTagPending: false,
  deleteUserTagError: null,
  getAllCertTypePending: false,
  getAllCertTypeError: null,
  allCertTypeById:{},
  certTypeTree:{},
  salaryRangeList:[],
  salaryRangePage:1,
  salaryRangeSize:10,
  salaryRangeTotal:0,
  salaryRangeById:{},
  salaryRangeModalType:"create",
  salaryRangeModalVisible:false,
  currentSalaryRange:{},
  getSalaryRangeListPending: false,
  getSalaryRangeListError: null,
  submitSalaryRangePending: false,
  submitSalaryRangeError: null,
  deleteSalaryRangePending: false,
  deleteSalaryRangeError: null,
  salaryTypeList:[],
  salaryTypePage:1,
  salaryTypeSize:10,
  salaryTypeTotal:0,
  salaryTypeById:{},
  salaryTypeModalType:"create",
  salaryTypeModalVisible:false,
  currentSalaryType:{},
  getSalaryTypeListPending: false,
  getSalaryTypeListError: null,
  submitSalaryTypePending: false,
  submitSalaryTypeError: null,
  deleteSalaryTypePending: false,
  deleteSalaryTypeError: null,
  getAllSalaryTypePending: false,
  getAllSalaryTypeError: null,
  allsalaryTypeList:[],
  allsalaryTypeById:{},
  workExperienceList:[],
  workExperiencePage:1,
  workExperienceSize:10,
  workExperienceTotal:0,
  workExperienceById:{},
  workExperienceModalType:"create",
  workExperienceModalVisible:false,
  currentWorkExperience:{},
  getWorkExperienceListPending: false,
  getWorkExperienceListError: null,
  submitWorkExperiencePending: false,
  submitWorkExperienceError: null,
  deleteWorkExperiencePending: false,
  deleteWorkExperienceError: null,
  industryTypeList:[],
  industryTypePage:1,
  industryTypeSize:10,
  industryTypeTotal:0,
  industryTypeById:{},
  industryTypeModalType:"create",
  industryTypeModalVisible:false,
  currentIndustryType:{},
  getIndustryTypeListPending: false,
  getIndustryTypeListError: null,
  submitIndustryTypePending: false,
  submitIndustryTypeError: null,
  deleteIndustryTypePending: false,
  deleteIndustryTypeError: null,
  getAllUserTagPending: false,
  getAllUserTagError: null,
  getAllCompanyTypePending: false,
  getAllCompanyTypeError: null,
  allCompanyTypeById:{},
  allCompanyTypeList:[],
  getAllAreaPending: false,
  getAllAreaError: null,
  allAreaById:{},
  allAreaList:[],
  getAllIndustryTypePending: false,
  getAllIndustryTypeError: null,
  allIndustryTypeById:{},
  allIndustryTypeList:[],
  getAllEduPending: false,
  getAllEduError: null,
  allEduById:{},
  allEduList:[],
  getAllExperiencePending: false,
  getAllExperienceError: null,
  allWorkExperienceById:{},
  allWorkExperienceList:[],
  getAllBenifitsPending: false,
  getAllBenifitsError: null,
  allBenefitsById:{},
  allBenefitsList:[],
  positionCategoyList:[],
  getPositionCategoryPending: false,
  getPositionCategoryError: null,
  getAllChildPostionPending: false,
  getAllChildPostionError: null,
  allChildPositionList:[],
  allChildCount:0,
  allChildPage:1,
  allPositionCatogoryCount:0,
  cuPositionCatogoryPage:1,
  getPositionListwithCaterogyPending: false,
  getPositionListwithCaterogyError: null,
  addCategoryChildPositionPending: false,
  addCategoryChildPositionError: null,
  removeCategoryChildPositionPending: false,
  removeCategoryChildPositionError: null,
  submitPositionListTypePending: false,
  submitPositionListTypeError: null,
  submitPositionNameTypePending: false,
  submitPositionNameTypeError: null,
  submitTemplateModifyTypePending: false,
  submitTemplateModifyTypeError: null,
  addCurrentTagsPending: false,
  addCurrentTagsError: null,
  submitdelTagPending: false,
  submitdelTagError: null,
  getChildPositionListPending: false,
  getChildPositionListError: null,
  
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/system/redux/initialState.js